import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'

import router from './router'
import {store} from './store';

import api from "./components/helpers/api";

import * as VueGoogleMaps from "vue2-google-maps";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ErrorPage from 'vue-error-page';
import AudioRecorder from 'vue-audio-recorder'

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import VueGtag from "vue-gtag";

import VueMeta from 'vue-meta'

import {Datetime} from 'vue-datetime';

import 'vue-datetime/dist/vue-datetime.css'


const VueInputMask = require('vue-inputmask').default;

Vue.use(VueI18n);
Vue.use(Loading);
Vue.use(AudioRecorder);

Vue.use(VueInputMask);

Vue.use(VueGtag, {
    config: {id: "UA-107138827-9"}
});


window.eventBus = new Vue();

Vue.use(ErrorPage, {
    tagName: 'app-view',
    bus: 'eventBus',
    event: 'error-page',
    resolver: (component) => {
        return require('./components/pages/errors/' + component).default;
    }
});

Vue.use(VueSweetalert2);

Vue.use(VueMeta);

Vue.component('datetime', Datetime);

Vue.config.productionTip = false;

api.defaults.timeout = 10000;


api.interceptors.request.use(
    config => {
        const token = store.getters.getAccessToken;
        if (token) {
            config.headers.common["Authorization"] = `Bearer ${store.getters.getAccessToken || ''}`
        }

        config.headers.common['Content-Type'] = 'application/json';
        config.headers.common['Accept'] = 'application/json';
        config.headers.common['Browser-Uid'] = store.getters.getBrowserUid

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

Vue.prototype.$http = api;

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDvfVq9r4YBDqTa8w79PiA8XKWBl4st1EI"
    }
});

const messages = {
    'en-US': {
        ui: {
            finishButton: 'Finish',
            nextButton: 'Next',
            requiredError: 'Field is required',
            emailError: 'Please input valid email',
            takeSurvey: 'Take Survey',
            logout: 'Logout',
            selectSurvey: 'Select Survey',
            finishText: 'Thank You!',
            againText: 'Again',
            oopsText: 'Oops!',
            accessDeniedText: "We are sorry but <b>access is denied.</b> This error indicate that access to the requested resource is forbidden for some reason or you are completed survey.\n" +
                "                        If you have some questions please contact us by email <b>dev@mail.com</b>",
            returnButton: 'Return to cabinet',
            recordAudioNotSupported: 'Record audio is not supported on this device',
            receiveCode: 'Get code',
            confirmCode: 'Check code',
            codeValid: 'Phone verified',
            luxonCode: 'en-US',
            cancel: 'Cancel',
            errorSendingResult: 'Error when sending. Check for fill one answer',
            close: 'Close',
            error: 'Error',
            closePageText: 'You can close this page',
            selectOption: 'Select option'
        }
    },
    'uk-UA': {
        ui: {
            finishButton: 'Відправити',
            nextButton: 'Далі',
            requiredError: "Поле обов'язкове для заповнення",
            takeSurvey: 'Пройти опитування',
            logout: 'Вийти',
            selectSurvey: 'Вибрати опитування',
            finishText: 'Щиро дякуємо за приділений час!',
            againText: 'Повторити',
            oopsText: 'Ой!',
            accessDeniedText: "Ця помилка вказує на те, що доступ до ресурсу з якоїсь причини заборонений або ви завершили опитування. Якщо у вас є якісь питання, зв'яжіться з нами електронною поштою <b>dev@mail.com</b>",
            returnButton: 'Назад до кабінету',
            recordAudioNotSupported: 'Запис аудіо не підтримується на цьому присторої',
            receiveCode: 'Отримати смс-код',
            confirmCode: 'Перевірити',
            codeValid: 'Телефон підтверджено',
            luxonCode: 'ua-UA',
            cancel: 'Відмінити',
            errorSendingResult: 'Помилка при відправленні. Будь ласка, дайте відповідь на питання з анкети',
            close: 'Закрити',
            error: 'Помилка',
            closePageText: 'Цю сторінку можна закрити',
            selectOption: 'Виберіть варіант',
            emailError: 'Введіть правильний email',
        }
    },
    'ru-RU': {
        ui: {
            finishButton: 'Отправить',
            nextButton: 'Дальше',
            requiredError: 'Поле обязательное для заполнения',
            takeSurvey: 'Пройти опрос',
            logout: 'Выйти',
            selectSurvey: 'Выбрать опрос',
            finishText: 'Спасибо!',
            againText: 'Повторить',
            oopsText: 'Ой!',
            accessDeniedText: "К сожалению, <b>доступ запрещен. </b> Эта ошибка указывает на то, что доступ к ресурсу по какой-либо причине запрещен или вы уже завершили опрос. Если у вас есть вопросы, свяжитесь с нами по электронной почте <b>dev@mail.com</b>",
            returnButton: 'Назад в кабинет',
            recordAudioNotSupported: 'Запись аудио не поддерживается на этом устройстве',
            receiveCode: 'Получить смс-код',
            confirmCode: 'Проверить',
            codeValid: 'Телефон подтвержден',
            luxonCode: 'ru-RU',
            cancel: 'Отмена',
            errorSendingResult: 'Ошибка при отправке. Пожалуйста, дайте ответ на вопрос из анкеты',
            close: 'Закрыть',
            error: 'Ошибка',
            closePageText: 'Эту страницу можно закрыть',
            selectOption: 'Выберите вариант'

        }
    }
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en-US', // set locale
    messages, // set locale messages
});


/* eslint-disable */
new Vue({
    render: h => h(App),
    router,
    store,
    i18n,
    components: {
        App
    }
}).$mount('#app');
